import DateRangePicker from "daterangepicker";
// var DateRangePicker = require("./daterangepicker")

export const getLang =  () => {
        var curLang,
            langAttr = $('html').attr('lang').toLowerCase();

        if (langAttr == 'en') {
            curLang = 'en';
        } else if (langAttr == 'zh-hk') {
            curLang = 'tc';
        } else if (langAttr == 'zh-cn') {
            curLang = 'sc';
        } else {
            curLang = 'en';
        }

        return curLang;
    };

export const langArg = (_arg) => {
        var cur_lang = getLang();
        return _arg[cur_lang];
    };


export const jsRangeDatePicker = (function () {

        var timeFormatSet = {
            tc: {
                date: 'DD/MM/YYYY',
                time: 'HH:mm'
            },
            sc: {
                date: 'DD/MM/YYYY',
                time: 'HH:mm'
            },
            en: {
                date: 'DD/MM/YYYY',
                time: 'HH:mm'
            }
        };

        var opts = {
            "singleDatePicker": true,
            "timePicker": false,
            "timePickerSeconds": true,
            "timePicker24Hour": true,
            "buttonClasses": "btn",
            "applyButtonClasses": "daterangepicker__apply",
            "cancelClass": "daterangepicker__cancel",
            "autoApply": false,
            "showDropdowns": true,
            "autoUpdateInput": true,
            "defaultDate": null,
            "formattedMonthPattern": 'YYYY-MM-DD'
        };

        var localizeSet = {
            tc: {
                "format": timeFormatSet[getLang()].date,
                "separator": " - ",
                "applyLabel": "確定",
                "cancelLabel": "清除",
                "fromLabel": "由",
                "toLabel": "到",
                "customRangeLabel": "自訂",
                "weekLabel": "W",
                "daysOfWeek": [
                    "日",
                    "一",
                    "二",
                    "三",
                    "四",
                    "五",
                    "六"
                ],
                "monthNames": [
                    "一月",
                    "二月",
                    "三月",
                    "四月",
                    "五月",
                    "六月",
                    "七月",
                    "八月",
                    "九月",
                    "十月",
                    "十一月",
                    "十二月"
                ],
                "firstDay": 1
            },
            sc: {
                "format": timeFormatSet[getLang()].date,
                "separator": " - ",
                "applyLabel": "确定",
                "cancelLabel": "清除",
                "fromLabel": "由",
                "toLabel": "到",
                "customRangeLabel": "自订",
                "weekLabel": "W",
                "daysOfWeek": [
                    "日",
                    "一",
                    "二",
                    "三",
                    "四",
                    "五",
                    "六"
                ],
                "monthNames": [
                    "一月",
                    "二月",
                    "三月",
                    "四月",
                    "五月",
                    "六月",
                    "七月",
                    "八月",
                    "九月",
                    "十月",
                    "十一月",
                    "十二月"
                ],
                "firstDay": 1
            },
            en: {
                "format": timeFormatSet[getLang()].date,
                "separator": " - ",
                "applyLabel": "Apply",
                "cancelLabel": "Clear",
                "fromLabel": "From",
                "toLabel": "To",
                "customRangeLabel": "Custom",
                "weekLabel": "W",
                "daysOfWeek": [
                    "SUN",
                    "MON",
                    "TUE",
                    "WED",
                    "THU",
                    "FRI",
                    "SAT"
                ],
                "monthNames": [
                    "JAN",
                    "FEB",
                    "MAR",
                    "APR",
                    "MAY",
                    "JUN",
                    "JUL",
                    "AUG",
                    "SEP",
                    "OCT",
                    "NOV",
                    "DEC"
                ],
                "firstDay": 1
            }
        }

        function setup($_c) {
            var $c = ($_c) ? $_c : $('body');
            var $dateRange__container = $('.js-daterangeBox', $c);

            $dateRange__container.each(function () {
                var $drc = $(this),
                    $dr = $(this).find('input').not('.drp-inited'),
                    daterange__opts = $.extend(true, {}, opts, { locale: localizeSet[getLang()] });

                if ($drc.hasClass('js-daterangeBox--date')) {
                    daterange__opts = $.extend(true, {}, daterange__opts, {
                        singleDatePicker: true,
                        locale: {
                            format: timeFormatSet[getLang()].date,
                        },
                    });
                }

                if ($drc.hasClass('js-daterangeBox--time')) {
                    daterange__opts = $.extend(true, {}, daterange__opts, {
                        timePicker: true,
                        timePickerSeconds: false,
                        locale: {
                            format: timeFormatSet[getLang()].time,
                        },
                    });
                }

                // allow null value for optional field
                if ($drc.hasClass('js-daterangeBox--init-empty')) {
                    daterange__opts = $.extend({}, daterange__opts, {
                        autoUpdateInput: false,
                    });
                }

                // set default value for mandatory field
                if ($dr.val().trim() == '' && !$drc.hasClass('js-daterangeBox--init-empty')) {
                    daterange__opts = $.extend({}, daterange__opts, {
                        startDate: moment().format(daterange__opts.locale.format),
                    });
                }

                if ($drc.hasClass('js-daterangeBox--time')) {
                    $dr.on('show.daterangepicker', function (ev, picker) {
                        picker.container.find('.calendar-table').hide();
                        picker.container.find('.drp-calendar.left').css('padding-right', function () {
                            return $(this).css('padding-left');
                        });
                    });
                }

                // Init
                let daterangepicker = new DateRangePicker($dr[0], daterange__opts);

                function handleDateRangePickerApply(ev) {
                    // console.log('apply.daterangepicker', ev, ev.detail);
                    ev.target.value = moment(ev.detail.startDate).format(daterange__opts.locale.format);
                    ev.target.dispatchEvent(new Event('change'));
                }

                function handleDateRangePickerCancel(ev, picker) {
                    // console.log('cancel.daterangepicker');
                    ev.target.value = '';
                    ev.target.dispatchEvent(new Event('change'));
                }

                $dr[0].addEventListener('apply.daterangepicker', handleDateRangePickerApply);
                $dr[0].addEventListener('cancel.daterangepicker', handleDateRangePickerCancel);


                $dr.on('focus', function () {
                    setTimeout(function () {
                        $dr.data('js-daterangeBox--datetime', $dr.val().trim());
                    }, 100);
                });

                $dr.on('blur', function () {
                    setTimeout(function () {
                        var trimSpaceVal = $dr.val().trim().replace(/\s\s+/g, ' ');
                        if (moment(trimSpaceVal, daterange__opts.locale.format, true).isValid()) {
                            $dr.val(trimSpaceVal);
                        } else if (trimSpaceVal !== '') {
                            $dr.val($dr.data('js-daterangeBox--datetime'));
                        }
                    }, 100);
                });

                $dr.addClass('drp-inited');
            });
        }

        return {
            init: setup
        };
    }());


export const dropzoneInit = (option) => {
    if (option === undefined) option = [];
    var $elm = $('.form-file-upload').not('.form-file-upload-init');
    if (!$elm.length) return;

    var locale = {
        tc: {
            dictDefaultMessage: '拖放文件到這裡',
            dictFileTooBig: '無法上傳此文件，文件不能大於 {{max_file_size}}。',
            dictRemoveFile: '刪除',
            dictCancelUpload: '取消上傳',
            dictCancelUploadConfirmation: '您確定要取消上傳嗎？',
            dictInvalidFileType: '無法上傳此文件，不支援此檔案類型或格式',
            dictMaxFilesExceeded: '無法上傳此文件，檔案數量超出上限',
            dictFallbackMessage: '你的瀏覽器不支援拖放上傳檔案',
        },
        sc: {
            dictDefaultMessage: '拖放文件到这里',
            dictFileTooBig: '无法上传此文件，文件不能大于 {{max_file_size}}。',
            dictRemoveFile: '删除',
            dictCancelUpload: '取消上传',
            dictCancelUploadConfirmation: '您确定要取消上传吗？',
            dictInvalidFileType: '无法上传此文件，不支援此档案类型或格式',
            dictMaxFilesExceeded: '无法上传此文件，档案数量超出上限',
            dictFallbackMessage: '你的浏览器不支援拖放上传档案',
        },
        en: {
            dictDefaultMessage: 'Drag and drop files here',
            dictFileTooBig: 'This file cannot be uploaded. File size cannot be larger than {{max_file_size}}.',
            dictRemoveFile: 'Remove',
            dictCancelUpload: 'Cancel upload',
            dictCancelUploadConfirmation: 'Are you sure you want to cancel this upload?',
            dictInvalidFileType: 'This file cannot be uploaded. File type or format is not supported',
            dictMaxFilesExceeded: 'This file cannot be uploaded. Exceed the maximum number of files.',
            dictFallbackMessage: "Your browser does not support drag'n'drop file uploads",
        }
    };

    $elm.each(function () {
        var $this = $(this);
        var attID = $this.attr('id');
        var id = '#' + attID;
        var previewID = 'dz-preview-' + attID;
        var listUrl = $this.data('dz-file-url') + '/get';
        var uploadUrl = $this.data('dz-file-url') + '/put';
        var removeUrl = $this.data('dz-file-url') + '/delete';
        var maxFiles = $this.data('maxfiles');
        var maxfilesize_mb = $this.data('maxfilesize');
        var acceptmime = $this.data('acceptmime');
        var hasSuccess = false;
        var $previewContainer = $('<div class="dz-preview-container"></div>');

        $this.append($previewContainer.prop('id', previewID));

        $(id).dropzone({
            url: uploadUrl,
            maxFiles: maxFiles,
            maxFilesize: maxfilesize_mb,
            acceptedFiles: acceptmime,
            dictDefaultMessage: locale[getLang()].dictDefaultMessage,
            thumbnailMethod: "contain",
            previewsContainer: $('#' + previewID)[0],
            createImageThumbnails: false,
            addRemoveLinks: true,
            dictCancelUpload: locale[getLang()].dictCancelUpload,
            dictCancelUploadConfirmation: locale[getLang()].dictCancelUploadConfirmation,
            dictRemoveFile: '<span class="dz-remove__row"><span class="dz-remove__icon">&#x2715;</span> <span class="dz-remove__txt">' + locale[getLang()].dictRemoveFile + '</span></span>',
            dictFileTooBig: locale[getLang()].dictFileTooBig,
            dictInvalidFileType: locale[getLang()].dictInvalidFileType,
            dictMaxFilesExceeded: locale[getLang()].dictMaxFilesExceeded,
            dictFallbackMessage: locale[getLang()].dictFallbackMessage,
            previewTemplate: `
          <div class="dz-preview dz-file-preview mb-3 mr-3">
            <div class="align-items-center d-flex flex-wrap">
              <div class="dz-details">
                <div class="dz-filename">
                  <div class="dz-progress">
                    <span class="dz-upload" data-dz-uploadprogress></span>
                  </div>
                  <span data-dz-name></span> (<span class="dz-size"><span data-dz-size></span>)</span>
                </div>
                <div class="dz-error-message text-danger" data-dz-errormessage></div>
              </div>
            </div>
          </div>
        `,
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            },
            removedfile: function (file) {
                $.ajax({
                    headers: {
                        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                    },
                    type: 'POST',
                    url: removeUrl,
                    data: { filename: file.name },
                    success: function (data) {
                        console.log("File has been successfully removed!!");
                    },
                    error: function (e) {
                        console.error(e);
                    }
                });
                var fileRef;
                return (fileRef = file.previewElement) != null ?
                    fileRef.parentNode.removeChild(file.previewElement) : void 0;
            },
            init: function () {
                var hasSuccess = false;
                var thisDropzone = this;
                $.get(listUrl, function (data) {
                    $.each(data, function (key, file) {
                        thisDropzone.options.addedfile.call(thisDropzone, file);
                        $(file.previewElement).addClass('dz-complete')
                        $(file.previewElement).find('.dz-image img, .dz-success-mark, .dz-error-mark').hide();
                        file.accepted = true;
                        thisDropzone.files.push(file);
                    });
                });
                thisDropzone.element.classList.add('form-file-upload-init');
            },
            success: function (file, response) {
                if (response.status === 'success') {
                    if (option.success && typeof option.success == 'function') {
                        option.success(file, response);
                    }
                    $(file.previewElement).closest('.dz-preview-container').find('.dz-duplicate').remove();
                    hasSuccess = true;
                } else {
                    $(file.previewElement).addClass("dz-error").find('.dz-error-message').text(response.message);
                }
            },
            error: function (file, response, xhr) {
                if (option.error && typeof option.error == 'function') {
                    option.error(file, response, xhr);
                }
                if (response.message) {
                    if (response.status === 'duplicate') {
                        $(file.previewElement).addClass('dz-duplicate');
                    }
                    $(file.previewElement).addClass("dz-error").find('.dz-error-message').text(response.message);
                } else {
                    response = response.replace("{{max_file_size}}", maxfilesize_mb + 'MB');
                    response = response.replace("{{max_file_number}}", maxFiles);
                    $(file.previewElement).addClass("dz-error").find('.dz-error-message').text(response);
                }
                $(file.previewElement).find('[data-dz-name]').css('text-decoration', 'line-through');
            },
            queuecomplete: function () {
                if (hasSuccess && option.queuecomplete && typeof option.queuecomplete == 'function') {
                    option.queuecomplete();
                }
                hasSuccess = false;
            },
            reset: function () {
                if (option.reset && typeof option.reset == 'function') {
                    option.reset();
                }
                $('.upload').removeClass('dz-started');
            }
        });
    });
}
